import { createFileRoute } from '@tanstack/react-router';
import A2UIPreviewWorkbenchPage from '@/a2ui/preview/A2UIPreviewWorkbenchPage';
import { loadTypedA2UIRouteData } from '@/a2ui/router/loadA2UIRouteDataClient';

export const Route = createFileRoute('/_workbench/a2ui-preview/imported/$importKey')({
  loader: ({ params }) => loadTypedA2UIRouteData(`/a2ui-preview/imported/${encodeURIComponent(params.importKey)}`, 'preview'),
  component: () => {
    const data = Route.useLoaderData();
    return <A2UIPreviewWorkbenchPage initialRaw={data.initialRaw} monacoSsrHtml={data.monacoSsrHtml} copy={data.copy} documentKey={data.documentKey} />;
  },
});
